import * as React from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';


export default function DataTable(props) {
  const {columns, visibility, data, quickFilterParser, title, filterTitle, options, actions, model, setmodel, sx, getRowId = (row) => row.id, onCellClick} = props
  return (
      <DataGrid
        localeText={{
          noRowsLabel: " -  ",
          toolbarColumns: "columnas",
          toolbarFilters: "filtrar",
          toolbarQuickFilterPlaceholder: filterTitle || "Buscar titulo, asin, publicacion ...",
          filterPanelColumns: "Columnas",
          filterOperatorContains: "contiene",
          filterOperatorEquals: "igual a",
          filterOperatorStartsWith: "inicia con",
          filterOperatorEndsWith: "termina con",
          filterOperatorIs: "igual a",
          filterOperatorNot: "diferente de",
          filterOperatorAfter: "despues de",
          filterOperatorOnOrAfter: "ahora o despues de",
          filterOperatorBefore: "antes de",
          filterOperatorOnOrBefore: "ahora o antes de",
          filterOperatorIsEmpty: "vacio",
          filterOperatorIsNotEmpty: "no vacio",
          filterOperatorIsAnyOf: "cualquiera de ",
          'filterOperator=': "igual a",
          'filterOperator!=': "diferente de",
          'filterOperator>': "mayor que",
          'filterOperator>=': "mayor o igual que",
          'filterOperator<': "menor que",
          'filterOperator<=': "menor o igual que",
        }}
        showQuickFilter
        ignoreDiacritics
        rows={data}
        getRowId={getRowId}
        columns={columns}
        pagination
        rowsPerPageOptions={options.pageSizes}
        checkboxSelection={options.selection}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: {
              debounceMs: 500,
              quickFilterParser: quickFilterParser || ((searchInput) => searchInput.split(' ')),
            },
          },
        }}
        columnVisibilityModel={visibility}
        disableColumnSelector
        disableDensitySelector
        disableRowSelectionOnClick
        onRowSelectionModelChange={(newSelectionModel) => {
          setmodel(newSelectionModel);
        }}
        rowSelectionModel={model}
        scrollbarSize={50}
        getRowHeight={() => 'auto'}
        {...(onCellClick ? { onCellClick } : {})}
        sx={{
          "& .MuiDataGrid-toolbarContainer button:nth-child(2)": {
            display: "none"
          },
          "& .MuiDataGrid-toolbarQuickFilter": {
            flex: 2
          },
          ...sx
        }}
      />
  );
}